import { useContext } from "react";
import UserAvatar from "../../../components/generic/UserAvatar";
import { AuthContext } from "../../../contexts/auth.context";
import { LogOut, Pencil, Settings, User, X } from "lucide-react";
import { Link } from "react-router";

export default function SettingsModal({open, onClose}: {
    open: boolean;
    onClose: () => void;
}) {

    const auth = useContext(AuthContext);

    return (
        <>
        <input readOnly type="checkbox" className="modal-toggle" checked={open} />
        <div className="modal">
            <div className="user-modal">
                <div>
                    <div className="flex items-center">
                        <div className="w-[42px]">
                        </div>
                        <div className="flex-1 text-center flex items-center gap-2 justify-center">
                            <div className="avatar"><div className="w-4"><img src="/logo192.png" alt="logo" /></div></div>
                            <p>Lister</p>
                        </div>
                        <div>
                            <button onClick={onClose} className="btn btn-sm btn-ghost"><X size={18} /></button>
                        </div>
                    </div>
                    <div className="bg-base-300 rounded-md">
                        <div className="grid grid-cols-[auto_1fr] p-4 gap-2 items-center">
                            <div>
                                <UserAvatar id={auth.user?.id || 0} className="w-12" />
                            </div>
                            <div className="overflow-hidden text-xs">
                                <p>{auth.user?.profile.firstName ? `${auth.user.profile.firstName} ${auth.user.profile.lastName || ""} (${auth.user.username})` : auth.user?.username}</p>
                                <p className="opacity-70 overflow-hidden text-ellipsis">{auth.user?.email}</p>
                            </div>
                        </div>

                        <div className="text-center mt-2 mb-8">
                            <Link to={'/profile'} className="btn btn-outline border-[#ffffff33] btn-sm"><User size={16} /> Your profile</Link>
                        </div>

                        <ul className="menu w-full p-0">
                            <li><span className="py-2"><Settings size={18} className="mr-4" /> Account</span></li>
                        </ul>
                    </div>
                    <ul className="menu w-full p-0">
                        <li><span onClick={auth.logout} className="py-2"><LogOut size={18} className="mr-4" /> Sign out</span></li>
                    </ul>
                </div>
            </div>
            <label onClick={onClose} className="modal-backdrop"></label>
        </div>
        </>
    );
}